export const LOADING_CONTACTS = "LOADING_CONTACTS";
export const GET_CONTACTS_LIST = "GET_CONTACTS_LIST";
export const REMOVE_CONTACT = "REMOVE_CONTACT";
export const ADD_CONTACT = "ADD_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const DELETE_CONTACT_LEAD = "DELETE_CONTACT_LEAD";
export const PRIMARY_CONTACT = "PRIMARY_CONTACT";